import React,  { useState, useEffect } from 'react';
import Loader from "react-loader-spinner";
import { useSelector, useDispatch } from 'react-redux';
import { FiArrowUp, FiArrowDown } from "react-icons/fi";
import { CSVLink } from 'react-csv';
import { useTranslation } from "react-i18next";
import { clearSession } from '../../utils/initiate';
import { toastMessage } from '../../utils/toast';
import * as reportActions from '../../Redux/Actions/report';
import Warning from '../Ui/400';
import { useSortableData } from '../../utils/sortableData';
import ReactPaginate from 'react-paginate';

const Reports = ({ history }) => {

    let itemsPerPage = 10;
    const [loading, setLoading] = useState(false);
    const [clearFilter, setClearFilter] = useState(false);
    const [data, setData] = useState([]);
    const [csvData, setCsvData] = useState([]);
    const [staffName, setStaffName] = useState('');
    const [processName, setProcessName] = useState('');
    const [jobStatus, setJobStatus] = useState('');
    const [customerName, setCustomerName] = useState('');
    const [staffNameData, setStaffNameData] = useState([]);
    const [processNameData, setProcessNameData] = useState([]);
    const [jobStatusData, setJobStatusData] = useState([]);
    const [customerNameData, setCustomerNameData] = useState([]);
    const [errStatus, setErrStatus] = useState(200);
    const userData = useSelector(({User}) => User.data);
    const dispatch = useDispatch();
    const [currentItems, setCurrentItems] = useState([]);
    const [pageCount, setPageCount] = useState(0);
    const [itemOffset, setItemOffset] = useState(0);
    const { t } = useTranslation();

    useEffect(() => {
        setLoading(true);
        let payload = {
            customerName: (customerName === '') ? null : customerName, staffName: (staffName === '') ? null : staffName, processName: (processName === '') ? null : processName, jobStatus: (jobStatus === '') ? null : jobStatus
        };
        let filterSelected = ((customerName === '') && (staffName === '') && (processName === '') && (jobStatus === ''));
        reportActions.getAllAdminJobs(filterSelected ? {} : payload).then(res => {
            if(res && res.data){
                let reportData = res.data;
                setData(reportData);
                filterData(reportData);
                let csvDataFormat = reportData.map(({jobInfo, customerInfo, staffInfo, typingCenter}, index) => ({'S No': index+1, 'Job ID': jobInfo.jobId, Customer: customerInfo, Process: jobInfo.processName, Staff: staffInfo, 'Typing Center': typingCenter, 'Transaction Amount': jobInfo.transactionAmount, 'Transaction Status': jobInfo.transactionStatus, Status: jobInfo.status}));
                setCsvData(csvDataFormat);
            }else{
                toastMessage('error', 'Unable to load the jobs');
            }
            setLoading(false);
        }).catch(err => {
            setErrStatus(err.response.status);
            (err.response.status === 401) && clearSession(dispatch, history);
        });
    }, [dispatch, history, userData, staffName, processName, jobStatus, customerName]);

    const filterData = (reportData) => {
        let staffData = reportData.map(({staffInfo}) => ({staffInfo}));
        let processData = reportData.map(({jobInfo}) => ({processName: jobInfo.processName}));
        let statusData = reportData.map(({jobInfo}) => ({status: jobInfo.status}));
        let customerData = reportData.map(({customerInfo}) => ({customerInfo}));

        staffData = staffData.filter((v,i,a)=>a.findIndex(t=>(t.staffInfo === v.staffInfo)) === i);
        processData = processData.filter((v,i,a)=>a.findIndex(t=>(t.processName === v.processName)) === i);
        statusData = statusData.filter((v,i,a)=>a.findIndex(t=>(t.status === v.status)) === i);
        customerData = customerData.filter((v,i,a)=>a.findIndex(t=>(t.customerInfo === v.customerInfo)) === i);

        setStaffNameData(staffData);
        setProcessNameData(processData);
        setJobStatusData(statusData);
        setCustomerNameData(customerData);
    };

    useEffect(() => {
        const endOffset = itemOffset + itemsPerPage;
        setCurrentItems(data.slice(itemOffset, endOffset));
        setPageCount(Math.ceil(data.length / itemsPerPage));
    }, [itemOffset, itemsPerPage, data]);

    const handlePageClick = (event) => {
        const newOffset = event.selected * itemsPerPage % data.length;
        setItemOffset(newOffset);
    };

    const {items, requestSort, sortConfig} = useSortableData(currentItems);

    if(errStatus === 400){
        return <Warning history={history} />;
    }

    return(
        <div className="container-fluid">
            <div className="page-title-box">
                <h4 className="page-title">{t("reports.title")}</h4>
            </div>
            <div className="row">
                {loading ? <Loader type="ThreeDots" color="#2d207d" height={40} width={40} style={{textAlign: 'center', marginBottom: '50px'}} />
                : <div className="card-body pt-0 pb-3">
                    <div className="tab-content">
                        <div className="d-flex align-items-center justify-content-between mb-3">
                            <div className="d-flex">
                                <select className="form-select me-3" value={staffName} onChange={e => {setStaffName(e.target.value); setClearFilter(false)}}>
                                    <option value="" disabled={true}>{t("reports.filters.selectStaff")}</option>
                                    {staffNameData.map(({staffInfo}) => <option key={staffInfo} value={staffInfo}>{staffInfo}</option>)}
                                </select>
                                <select className="form-select me-3" value={processName} onChange={e => {setProcessName(e.target.value); setClearFilter(false)}}>
                                    <option value="" disabled={true}>{t("reports.filters.selectProcess")}</option>
                                    {processNameData.map(({processName}) => <option key={processName} value={processName}>{processName}</option>)}
                                </select>
                                <select className="form-select me-3" value={jobStatus} onChange={e => {setJobStatus(e.target.value); setClearFilter(false)}}>
                                    <option value="" disabled={true}>{t("reports.filters.selectJobStatus")}</option>
                                    {jobStatusData.map(({status}) => <option key={status} value={status}>{status}</option>)}
                                </select>
                                <select className="form-select me-3" value={customerName} onChange={e => {setCustomerName(e.target.value); setClearFilter(false)}}>
                                    <option value="" disabled={true}>{t("reports.filters.selectCustomer")}</option>
                                    {customerNameData.map(({customerInfo}) => <option key={customerInfo} value={customerInfo}>{customerInfo}</option>)}
                                </select>
                                <div className="d-flex align-items-center" style={{whiteSpace: 'nowrap'}}>
                                    <input id="clearFilter" className="me-1" type="checkbox" checked={clearFilter} onChange={e => {setClearFilter(e.target.checked); setStaffName(''); setProcessName(''); setJobStatus(''); setCustomerName('')}} /> 
                                    <label htmlFor="clearFilter" className="m-0">{t("reports.filters.clearFilters")}</label>
                                </div>
                            </div>
                            <CSVLink data={csvData} filename={"back_office_reports.csv"} className="btn btn-primary">{t("reports.filters.download")}</CSVLink>
                        </div>
                        <div className="table-responsive">
                            <table className="table table-head-custom table-vertical-center table-head-bg">
                                <thead>
                                    <tr className="text-left">
                                        <th className="c-pointer" style={{width: '50px'}} onClick={() => requestSort('jobId')}><span className={(sortConfig && (sortConfig.key === 'jobId')) ? "text-primary" : "text-dark-75"}>{t("reports.manageReports.id")} {(sortConfig && (sortConfig.key === 'jobId')) && ((sortConfig.direction === 'ascending') ? <FiArrowUp /> : <FiArrowDown />)}</span></th>
                                        <th className="c-pointer" style={{width: '80px'}} onClick={() => requestSort('customerInfo')}><span  className={(sortConfig && (sortConfig.key === 'customerInfo')) ? "text-primary" : "text-dark-75"}>{t("reports.manageReports.user")} {(sortConfig && (sortConfig.key === 'customerInfo')) && ((sortConfig.direction === 'ascending') ? <FiArrowUp /> : <FiArrowDown />)}</span></th>
                                        <th className="c-pointer" style={{minWidth: '100px'}} onClick={() => requestSort('processName')}><span  className={(sortConfig && (sortConfig.key === 'processName')) ? "text-primary" : "text-dark-75"}>{t("reports.manageReports.process")} {(sortConfig && (sortConfig.key === 'process')) && ((sortConfig.direction === 'ascending') ? <FiArrowUp /> : <FiArrowDown />)}</span></th>
                                        <th className="c-pointer" style={{minWidth: '100px'}} onClick={() => requestSort('staffInfo')}><span  className={(sortConfig && (sortConfig.key === 'staffInfo')) ? "text-primary" : "text-dark-75"}>{t("reports.manageReports.staff")} {(sortConfig && (sortConfig.key === 'staffInfo')) && ((sortConfig.direction === 'ascending') ? <FiArrowUp /> : <FiArrowDown />)}</span></th>
                                        <th style={{minWidth: '100px'}}><span className="text-dark-75">{t("reports.manageReports.typingCenter")}</span></th>
                                        <th style={{minWidth: '100px'}}><span className="text-dark-75">{t("reports.manageReports.transactionAmount")}</span></th>
                                        <th style={{minWidth: '100px'}}><span className="text-dark-75">{t("reports.manageReports.transactionStatus")}</span></th>
                                        <th style={{minWidth: '100px'}}><span className="text-dark-75">{t("reports.manageReports.status")}</span></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {items.map(({customerInfo, jobInfo, staffInfo, typingCenter}, index) => {
                                        return(
                                            <tr key={index}>
                                                <td>
                                                    <span className="text-dark-75">{jobInfo.jobId}</span>
                                                </td>
                                                <td>
                                                    <span className="text-dark-75">{customerInfo}</span>
                                                </td>
                                                <td>
                                                    <span className="text-dark-75">{jobInfo.processName}</span>
                                                </td>
                                                <td>
                                                    <span className="text-dark-75">{staffInfo}</span>
                                                </td>
                                                <td>
                                                    <span className="text-dark-75">{typingCenter}</span>
                                                </td>
                                                <td>
                                                    <span className="text-dark-75">{jobInfo.transactionAmount}</span>
                                                </td>
                                                <td>
                                                    <span className="text-dark-75">{jobInfo.transactionStatus}</span>
                                                </td>
                                                <td style={{whiteSpace: 'nowrap'}}>
                                                    <span className={"p-2 badge-info"} style={{borderRadius: '3px', width: 'auto'}}>{jobInfo.status}</span>
                                                </td>
                                            </tr>
                                        )})}
                                </tbody>
                            </table>
                            {(pageCount > 1) && <ReactPaginate
                                breakLabel="..."
                                nextLabel=">"
                                previousLabel="<"
                                onPageChange={handlePageClick}
                                pageRangeDisplayed={5}
                                pageCount={pageCount}
                                pageClassName="page-item"
                                pageLinkClassName="page-link"
                                previousClassName="page-item"
                                previousLinkClassName="page-link"
                                nextClassName="page-item"
                                nextLinkClassName="page-link"
                                breakClassName="page-item"
                                breakLinkClassName="page-link"
                                containerClassName="pagination"
                                activeClassName="active"
                                renderOnZeroPageCount={null}
                            />}
                            {(data.length === 0) && <p className="text-center mt-5 mb-5">{t("reports.noDataAvailable")}</p>}
                        </div>
                    </div>
                </div>}
            </div>
        </div>
    );
};

export default Reports;